// @utilities
const apiURLBuilder = require('core/apiURLBuilder');
const { APIGet, APIPost } = require('utilities/APIRequestHelper');
const {
    EVENT_UNSUITABLE_PROFILE,
    recordLink,
    recordProcess,
    PROC_RA_SUITABILITY_TEST_CURRENT_ANSWER,
    PROC_END,
    PROC_FAIL,
    PROC_RA_SUITABILITY_TEST_FINISH_FORM,
    PROC_STEP,
    PROC_RA_SUITABILITY_TEST,
    PROC_RA_SUITABILITY_TEST_STEP_1,
    PROC_RA_SUITABILITY_TEST_STEP_2,
    PROC_RA_SUITABILITY_TEST_STEP_3,
    PROC_RA_SUITABILITY_TEST_STEP_4,
    PROC_RA_SUITABILITY_TEST_STEP_5,
    PROC_RA_SUITABILITY_TEST_STEP_6,
    PROC_RA_SUITABILITY_TEST_STEP_7,
    PROC_RA_SUITABILITY_TEST_STEP_8,
    PROC_RA_SUITABILITY_TEST_STEP_9,
    PROC_RA_SUITABILITY_TEST_STEP_10,
    PROC_RA_SUITABILITY_TEST_STEP_11,
    PROC_RA_SUITABILITY_TEST_STEP_12,
    SUSTAINABILITY_QUESTION_401,
} = require('utilities/tagging');
const { getFormattedLanguage } = require('../utilities/RALanguageHelper');
const PersonalDataHelper = require('utilities/personalDataHelper');
const { taggingEventHandled } = require('utilities/taggingEventHandled');
const {
    networthSliderValueToAnswer,
    horizonSliderValueToAnswer,
    riskSliderValueToAnswer,
    incomeValueToAnswer,
    outcomeValueToAnswer,
    mapInvestmentRowAnswerToValue,
    mapInvestmentRowValueToAnswer,
} = require('../utilities/RASuitabilityTestHelper');
const {
    isPrintOfficeMode,
    getCCOfficeChannel,
} = require('utilities/contactCenter/printerHelper');

// @constants
const actionTypes = require('../raConstants/actionTypes');
const {
    MODIFY_SUITABILITY_TEST,
    SUSTAINABILITY_QUESTIONS_SUITABILITY_TEST,
    SUSTAINABILITY_QUESTIONS_SUITABILITY_TEST_COUNTRIES,
    MIFID_TEST_CONTRACTED_PRODUCTS_COHERENCE_CONTROL,
    EVIDENCE_WEALTH_SUITABILITY_TEST,
    SUITABILITY_TEST_V6,
} = require('constants/flagBasedFeatures');
const { API_CHANNEL } = require('constants/index');

// @Contact Center
const actionTypesContactCenter = require('../raConstants/contactCenter/actionTypes');
const {
    zeroQuestionPresent,
} = require('../utilities/contactCenter/RAZeroQuestionHelper');
const {
    RA_ZERO_QUESTION_ID,
} = require('../raConstants/contactCenter/zeroQuestionCodes');

const {
    INCOME,
    EXPENSES,
    SUITABILITY_TEST,
    SUITABILITY_TEST_ACCORDION_QUESTION,
    SUITABILITY_TEST_STEP_0,
    SUITABILITY_TEST_STEP_1,
    SUITABILITY_TEST_STEP_2,
    SUITABILITY_TEST_STEP_3,
    SUITABILITY_TEST_STEP_4,
    SUITABILITY_TEST_STEP_5,
    SUITABILITY_TEST_STEP_6,
    SUITABILITY_TEST_STEP_7,
    SUITABILITY_TEST_STEP_8,
    SUITABILITY_TEST_STEP_9,
    SUITABILITY_TEST_STEP_10,
    SUITABILITY_TEST_STEP_11,
    SUITABILITY_TEST_STEP_12,
    SUITABILITY_TEST_MODAL_QUESTION_500,
    SUITABILITY_TEST_IN_PROGRESS,
    SUITABILITY_TEST_NO_TEST,
    SUITABILITY_TEST_EXPIRED,
    SUITABILITY_TEST_REDO,
    SUITABILITY_TEST_VALID,
    QUESTION_TO_FILTER_ON_1A_CASES,
    SUITABILITY_TEST_STEP_3_1,
} = require('../raConstants/index');

// @actions
const checkStatusActions = require('./RACheckStatus');
const wizardActions = require('./RAWizard');
const signaturePatternActions = require('actions/signaturePattern');
const brokerMyInvestments = require('actions/brokerMyInvestments');
const errorActions = require('actions/brokerError');

const setRetryReason = value => ({
    type: actionTypes.RA_SUITABILITY_TEST_RETRY_REASON_CHANGED,
    payload: {
        value,
    },
});

const updateKnowledgeOption = value => dispatch => {
    const isStepCompleted = value !== '';
    dispatch(wizardActions.updateWizardStep(SUITABILITY_TEST, isStepCompleted));
    dispatch({
        type: actionTypes.RA_SUITABILITY_TEST_UPDATE_KNOWLEDGE,
        payload: {
            value,
        },
    });
};

const updateFinancialAwarenessOption = value => dispatch => {
    const isStepCompleted = value !== '';
    dispatch(wizardActions.updateWizardStep(SUITABILITY_TEST, isStepCompleted));
    dispatch({
        type: actionTypes.RA_SUITABILITY_TEST_UPDATE_FINANCIAL,
        payload: {
            value,
        },
    });
};

const updateToolsAwarenessOption = (value, step) => dispatch => {
    const isStepCompleted = value !== '';
    dispatch({
        type: actionTypes.RA_SUITABILITY_TEST_UPDATE_TOOLS,
        payload: {
            value,
        },
    });
    dispatch(
        wizardActions.updateWizardStep(SUITABILITY_TEST, isStepCompleted, step),
    );
};

const updateMarketRiskOption = (value, step) => dispatch => {
    const isStepCompleted = value !== '';
    dispatch({
        type: actionTypes.RA_SUITABILITY_TEST_UPDATE_MARKET_RISK,
        payload: {
            value,
        },
    });
    dispatch(
        wizardActions.updateWizardStep(SUITABILITY_TEST, isStepCompleted, step),
    );
};

const updateCapitalRatioOption = value => dispatch => {
    const isStepCompleted = value !== '';

    dispatch(wizardActions.updateWizardStep(SUITABILITY_TEST, isStepCompleted));
    dispatch({
        type: actionTypes.RA_SUITABILITY_TEST_UPDATE_CAPITAL,
        payload: {
            value,
        },
    });
};

const updateBackupPlanOption = value => dispatch => {
    const isStepCompleted = value !== '';

    dispatch(wizardActions.updateWizardStep(SUITABILITY_TEST, isStepCompleted));
    dispatch({
        type: actionTypes.RA_SUITABILITY_TEST_UPDATE_BACKUP,
        payload: {
            value,
        },
    });
};

const changeCheckedOption = options => ({
    type: actionTypes.RA_SUITABILITY_TEST_SELECT_CHECKBOX_OPTION,
    payload: {
        options,
    },
});

const updateTemporalHorizonValue = value => dispatch => {
    const isStepCompleted = parseInt(value) > 0;
    dispatch(wizardActions.updateWizardStep(SUITABILITY_TEST, isStepCompleted));
    dispatch({
        type: actionTypes.RA_SUITABILITY_TEST_UPDATE_INVESTMENT_HORIZON_SLIDER,
        payload: {
            value,
        },
    });
};

const updateVolatilityValue = value => dispatch => {
    const shouldDisplayModal = value === 0;
    dispatch(
        wizardActions.shouldDisplayModal(SUITABILITY_TEST, shouldDisplayModal),
    );
    dispatch(wizardActions.updateWizardStep(SUITABILITY_TEST, true));
    dispatch({
        type: actionTypes.RA_SUITABILITY_TEST_UPDATE_VOLATILITY_VALUE,
        payload: {
            value,
        },
    });
};

const expandAccordionRow = expandedRowId => ({
    type: actionTypes.RA_SUITABILITY_TEST_EXPAND_ACCORDION_ROW,
    payload: {
        expandedRowId,
    },
});

const selectAccordionButton = (rowId, buttonId) => (dispatch, getState) => {
    dispatch({
        type: actionTypes.RA_SUITABILITY_TEST_SELECT_ACCORDION_BUTTON,
        payload: {
            rowId,
            buttonId,
        },
    });
    const shouldDisplayModal = getState()
        .raSuitabilityTest.get('answers')
        .slice(4, 15)
        .every(v => v === 'answer1');
    dispatch(
        wizardActions.shouldDisplayModal(SUITABILITY_TEST, shouldDisplayModal),
    );
};

const updateVolatilityInputValue = value => ({
    type: actionTypes.RA_SUITABILITY_TEST_UPDATE_VOLATILITY_INPUT_VALUE,
    payload: {
        value,
    },
});

const updateIncomingValue = value => (dispatch, getState) => {
    const outgoingValue = getState().raSuitabilityTest.getIn([
        'answers',
        '321',
    ]);
    const isStepCompleted =
        !isNaN(parseFloat(value)) && !isNaN(parseFloat(outgoingValue));

    dispatch(wizardActions.updateWizardStep(SUITABILITY_TEST, isStepCompleted));
    dispatch({
        type: actionTypes.RA_SUITABILITY_TEST_UPDATE_INCOMING_VALUE,
        payload: {
            value,
        },
    });
};

const updateOutgoingValue = value => (dispatch, getState) => {
    const incomingValue = getState().raSuitabilityTest.getIn([
        'answers',
        '320',
    ]);
    const isStepCompleted =
        !isNaN(parseFloat(incomingValue)) && !isNaN(parseFloat(value));

    dispatch(wizardActions.updateWizardStep(SUITABILITY_TEST, isStepCompleted));
    dispatch({
        type: actionTypes.RA_SUITABILITY_TEST_UPDATE_OUTGOING_VALUE,
        payload: {
            value,
        },
    });
};

const updateObjective = value => dispatch => {
    dispatch(wizardActions.updateWizardStep(SUITABILITY_TEST, true));
    dispatch({
        type: actionTypes.RA_SUITABILITY_TEST_UPDATE_OBJECTIVE,
        payload: {
            value,
        },
    });
};

const updateZeroQuestionOption = value => dispatch => {
    const isStepCompleted = value !== '';

    dispatch(wizardActions.updateWizardStep(SUITABILITY_TEST, isStepCompleted));
    dispatch({
        type: actionTypesContactCenter.RA_SUITABILITY_TEST_UPDATE_ZERO_QUESTION,
        payload: {
            value,
        },
    });
};

const setCoherenceError = (message, allowToPass = false, isNonBlocking) => ({
    type: actionTypes.RA_SUITABILITY_TEST_SET_COHERENCE_ERROR,
    payload: {
        message,
        allowToPass,
        isNonBlocking,
    },
});

const resetCoherenceError = () => ({
    type: actionTypes.RA_SUITABILITY_TEST_RESET_COHERENCE_ERROR,
});

function checkCoherenceValidations(
    currentQuestion,
    currentAnswer,
    immSuitabilityTest,
) {
    const questionsToCheck = immSuitabilityTest.getIn(
        ['validations', currentQuestion, currentAnswer],
        [],
    );
    let error;

    questionsToCheck.some((question, questionId) => {
        const questionAnswer = immSuitabilityTest.getIn([
            'answers',
            questionId,
        ]);
        const message = immSuitabilityTest.getIn([
            'validations',
            currentQuestion,
            currentAnswer,
            questionId,
            questionAnswer,
        ]);
        error = message;
        return error;
    });

    return error;
}

function checkAccordionCoherence(currentQuestion, immSuitabilityTest) {
    // Questions (F, G, H, I, J, K, L) respectivelyfrom step 4 to sum when answer selected is not coherent
    const step4Questions = ['110', '111', '112', '113', '114', '115'];
    let errorMessage;
    let error;

    const count = step4Questions.reduce((prev, questionId) => {
        const answer = immSuitabilityTest.getIn(['answers', questionId]);
        errorMessage = checkCoherenceValidations(
            currentQuestion,
            mapInvestmentRowValueToAnswer(questionId),
            immSuitabilityTest,
        );

        return errorMessage
            ? prev + mapInvestmentRowAnswerToValue(answer)
            : prev;
    }, 0);

    if (count > 1) {
        error = errorMessage;
    }

    return error;
}

const getStepIdentifier = (wizardIdentifier, currentStepIndex, getState) => {
    const immWizard = getState().raWizard;
    const immSteps = immWizard
        .getIn(['persistedWizards', wizardIdentifier, 'categories'])
        .flatMap(category => category.get('steps'));

    return immSteps.getIn([currentStepIndex, 'identifier']);
};

const zeroQuestionAnswered = () => ({
    type: actionTypes.RA_SUITABILITY_TEST_ANSWERED_QUESTION_ZERO,
});

const validateStep = (wizard, identifier, intent) => (dispatch, getState) => {
    const immSuitabilityTest = getState().raSuitabilityTest;
    const ffTestV6 = getState().flagBasedFeatures.get(SUITABILITY_TEST_V6);
    if (intent === '+1' || (intent === 'finalStep' && ffTestV6)) {
        const step = getStepIdentifier(wizard, identifier, getState);
        let valid = true;
        let currentStep = '';
        let currentQuestion = '';
        let currentAnswer = '';
        let mappedAnswer = '';
        let errorMessage = '';
        let warningMessage = '';
        let questions = '';
        let isNonBlocking = false;
        switch (step) {
            case SUITABILITY_TEST_STEP_1:
                currentStep = PROC_RA_SUITABILITY_TEST_STEP_1;
                currentQuestion = '101';
                currentAnswer = immSuitabilityTest.getIn([
                    'answers',
                    currentQuestion,
                ]);
                break;
            case SUITABILITY_TEST_STEP_2:
                currentStep = PROC_RA_SUITABILITY_TEST_STEP_2;
                currentQuestion = '102';
                currentAnswer = immSuitabilityTest.getIn([
                    'answers',
                    currentQuestion,
                ]);
                break;
            case SUITABILITY_TEST_STEP_3:
                currentStep = PROC_RA_SUITABILITY_TEST_STEP_3;
                if (ffTestV6) {
                    currentQuestion = '103';
                    currentAnswer = immSuitabilityTest.getIn([
                        'answers',
                        currentQuestion,
                    ]);
                } else {
                    const multiQuestions = ['103', '104'];
                    const multiAnswers = multiQuestions.map(question => {
                        return immSuitabilityTest.getIn(['answers', question]);
                    });
                    const includeErrors = multiQuestions.map(question => {
                        const answer = immSuitabilityTest.getIn([
                            'answers',
                            question,
                        ]);
                        return checkCoherenceValidations(
                            question,
                            answer,
                            immSuitabilityTest,
                        );
                    });
                    errorMessage = includeErrors.every(e => e);
                    valid = !errorMessage;
                    currentQuestion = multiQuestions.toString();
                    currentAnswer = multiAnswers.toString();
                }
                break;
            case SUITABILITY_TEST_STEP_3_1:
                currentStep = PROC_RA_SUITABILITY_TEST_STEP_3;
                if (ffTestV6) {
                    currentQuestion = '104';
                    currentAnswer = immSuitabilityTest.getIn([
                        'answers',
                        currentQuestion,
                    ]);
                }
                break;
            case SUITABILITY_TEST_STEP_4:
                currentStep = PROC_RA_SUITABILITY_TEST_STEP_4;
                questions = [
                    '106',
                    '107',
                    '108',
                    '109',
                    '110',
                    '111',
                    '112',
                    '113',
                    '114',
                    '115',
                ];
                currentQuestion = questions.toString();
                currentAnswer = questions
                    .map(question => {
                        return immSuitabilityTest.getIn(['answers', question]);
                    })
                    .toString();
                warningMessage = checkAccordionCoherence(
                    '105',
                    immSuitabilityTest,
                );
                break;
            case SUITABILITY_TEST_STEP_5:
                currentStep = PROC_RA_SUITABILITY_TEST_STEP_5;
                currentQuestion = '217';
                currentAnswer = immSuitabilityTest.getIn([
                    'answers',
                    currentQuestion,
                ]);
                break;
            case SUITABILITY_TEST_STEP_6:
                currentStep = PROC_RA_SUITABILITY_TEST_STEP_6;
                currentQuestion = '218';
                currentAnswer = immSuitabilityTest.getIn([
                    'answers',
                    currentQuestion,
                ]);
                mappedAnswer = horizonSliderValueToAnswer(currentAnswer);
                errorMessage = checkCoherenceValidations(
                    currentQuestion,
                    mappedAnswer,
                    immSuitabilityTest,
                );
                isNonBlocking = true;
                valid = !errorMessage;
                break;
            case SUITABILITY_TEST_STEP_7:
                currentStep = PROC_RA_SUITABILITY_TEST_STEP_7;
                currentQuestion = '219';
                currentAnswer = immSuitabilityTest.getIn([
                    'answers',
                    currentQuestion,
                ]);
                mappedAnswer = riskSliderValueToAnswer(currentAnswer);
                errorMessage = checkCoherenceValidations(
                    currentQuestion,
                    mappedAnswer,
                    immSuitabilityTest,
                );
                isNonBlocking = true;
                valid = !errorMessage;
                break;
            case SUITABILITY_TEST_STEP_8:
                // TODO: research previous foreign questions not found on OBK433-17688 either current test question mock
                currentStep = PROC_RA_SUITABILITY_TEST_STEP_8;
                questions = ['320', '321'];
                currentQuestion = questions.toString();
                currentAnswer = [INCOME, EXPENSES];
                break;
            case SUITABILITY_TEST_STEP_9:
                // TODO: research previous foreign questions not found on OBK433-17688 either current test question mock
                currentStep = PROC_RA_SUITABILITY_TEST_STEP_9;
                currentQuestion = '322';
                currentAnswer = immSuitabilityTest.getIn([
                    'answers',
                    currentQuestion,
                ]);
                break;
            case SUITABILITY_TEST_STEP_10:
                currentStep = PROC_RA_SUITABILITY_TEST_STEP_10;
                currentQuestion = '323';
                currentAnswer = immSuitabilityTest.getIn([
                    'answers',
                    currentQuestion,
                ]);
                break;
            case SUITABILITY_TEST_STEP_11:
                currentStep = PROC_RA_SUITABILITY_TEST_STEP_11;
                currentQuestion = immSuitabilityTest.get(
                    'currentSustainabilityQuestionId',
                );
                currentAnswer = immSuitabilityTest.getIn([
                    'answers',
                    currentQuestion,
                ]);
                break;
            case SUITABILITY_TEST_STEP_12:
                currentStep = PROC_RA_SUITABILITY_TEST_STEP_12;
                currentQuestion = ['402', '403', '404', '405'];
                immSuitabilityTest.getIn(['answers', '402']);
                const answersSelected = currentQuestion.map(id => {
                    const selectedAnswer = immSuitabilityTest.getIn([
                        'answers',
                        id,
                    ]);
                    return immSuitabilityTest
                        .toJS()
                        .questions[id].answers.find(answer => {
                            if (answer.id === selectedAnswer) {
                                return answer.label.title
                                    .split(' ')
                                    .splice(0, 9)
                                    .join(' ');
                            }
                        });
                });
                currentAnswer =
                    'respuesta-' +
                    answersSelected
                        .filter(answer => !!answer)
                        .map(answer => answer.label.title)
                        .join('_');
                break;
        }
        if (valid) {
            if (
                warningMessage &&
                !immSuitabilityTest.getIn(['coherenceError', 'allowToPass'])
            ) {
                dispatch(setCoherenceError(warningMessage, true));
            } else {
                if (step == SUITABILITY_TEST_STEP_0) {
                    dispatch(zeroQuestionAnswered());
                }
                if (intent !== 'finalStep') {
                    dispatch(
                        wizardActions.markStepAsCompleteAndAvanceTo(
                            wizard,
                            intent,
                        ),
                    );
                }
                if (currentQuestion === '401') {
                    const answerDescription = {
                        answer1: 'neutral',
                        answer2: 'intermedio',
                        answer3: 'avanzado',
                    };
                    const SelectedAnswerId = immSuitabilityTest.getIn([
                        'answers',
                        currentQuestion,
                    ]);
                    taggingEventHandled(
                        SUSTAINABILITY_QUESTION_401,
                        'finishOn401',
                        answerDescription[SelectedAnswerId],
                    );
                } else if (currentStep === PROC_RA_SUITABILITY_TEST_STEP_12) {
                    taggingEventHandled(
                        SUSTAINABILITY_QUESTION_401,
                        'finishOn402',
                        currentAnswer,
                    );
                } else {
                    recordLink(
                        PROC_RA_SUITABILITY_TEST,
                        PROC_RA_SUITABILITY_TEST_CURRENT_ANSWER + currentStep,
                        currentAnswer,
                    );
                }
            }
        } else {
            dispatch(setCoherenceError(errorMessage, false, isNonBlocking));
        }
    } else {
        dispatch(wizardActions.changeStepTo(wizard, intent));
    }
};

const continueFromModalWarning = (wizard, identifier, intent) => (
    dispatch,
    getState,
) => {
    const immSuitabilityTest = getState().raSuitabilityTest;
    const step = getStepIdentifier(wizard, identifier, getState);
    let currentStep, currentQuestion, currentAnswer, questions;
    switch (step) {
        case SUITABILITY_TEST_STEP_1:
            currentStep = PROC_RA_SUITABILITY_TEST_STEP_1;
            currentQuestion = '101';
            currentAnswer = immSuitabilityTest.getIn([
                'answers',
                currentQuestion,
            ]);
            break;
        case SUITABILITY_TEST_STEP_2:
            currentStep = PROC_RA_SUITABILITY_TEST_STEP_2;
            currentQuestion = '102';
            currentAnswer = immSuitabilityTest.getIn([
                'answers',
                currentQuestion,
            ]);
            break;
        case SUITABILITY_TEST_STEP_3:
            currentStep = PROC_RA_SUITABILITY_TEST_STEP_3;
            currentQuestion = '103';
            currentAnswer = immSuitabilityTest.getIn([
                'answers',
                currentQuestion,
            ]);
            break;
        case SUITABILITY_TEST_STEP_4:
            currentStep = PROC_RA_SUITABILITY_TEST_STEP_4;
            questions = [
                '105',
                '106',
                '107',
                '108',
                '109',
                '110',
                '111',
                '112',
                '113',
                '114',
            ];
            currentQuestion = questions.toString();
            currentAnswer = questions
                .map(question => {
                    return immSuitabilityTest.getIn(['answers', question]);
                })
                .toString();
            break;
        case SUITABILITY_TEST_STEP_5:
            currentStep = PROC_RA_SUITABILITY_TEST_STEP_5;
            currentQuestion = '217';
            currentAnswer = immSuitabilityTest.getIn([
                'answers',
                currentQuestion,
            ]);
            break;
        case SUITABILITY_TEST_STEP_6:
            currentStep = PROC_RA_SUITABILITY_TEST_STEP_6;
            currentQuestion = '218';
            currentAnswer = immSuitabilityTest.getIn([
                'answers',
                currentQuestion,
            ]);
            break;
        case SUITABILITY_TEST_STEP_7:
            currentStep = PROC_RA_SUITABILITY_TEST_STEP_7;
            currentQuestion = '219';
            currentAnswer = immSuitabilityTest.getIn([
                'answers',
                currentQuestion,
            ]);
            break;
        case SUITABILITY_TEST_STEP_8:
            currentStep = PROC_RA_SUITABILITY_TEST_STEP_8;
            questions = ['320', '321'];
            currentQuestion = questions.toString();
            currentAnswer = [INCOME, EXPENSES];
            break;
        default:
        case SUITABILITY_TEST_STEP_9:
            currentStep = PROC_RA_SUITABILITY_TEST_STEP_9;
            currentQuestion = '322';
            currentAnswer = immSuitabilityTest.getIn([
                'answers',
                currentQuestion,
            ]);
            break;
    }
    dispatch(wizardActions.markStepAsCompleteAndAvanceTo(wizard, intent));
    recordLink(
        PROC_RA_SUITABILITY_TEST,
        PROC_RA_SUITABILITY_TEST_CURRENT_ANSWER + currentStep,
        currentAnswer,
    );
};

const testCompleted = () => ({
    type: actionTypes.RA_SUITABILITY_TEST_COMPLETED,
});

const getTestResultInProgress = () => ({
    type: actionTypes.RA_SUITABILITY_GET_TEST_RESULT_REQUEST,
});

const getTestResultSuccess = response => ({
    type: actionTypes.RA_SUITABILITY_GET_TEST_RESULT_SUCCESS,
    payload: response,
});

const getTestResultFailure = error => ({
    type: actionTypes.RA_SUITABILITY_GET_TEST_RESULT_FAILURE,
    payload: { error },
});

const getTestResult = (filter = 2, markTestAsCompleted = false) => dispatch => {
    dispatch(getTestResultInProgress());

    const language = getFormattedLanguage();
    const requestData = {
        header: {
            'Accept-Language': language,
        },
    };
    const params = {
        filter,
        language,
    };

    return APIGet(
        dispatch,
        apiURLBuilder.getURL('raGetRiskCategory', params),
        requestData,
    )
        .then(response => {
            dispatch(getTestResultSuccess(response));
            markTestAsCompleted && dispatch(testCompleted());
        })
        .catch(error => {
            if (error.error) {
                dispatch(getTestResultFailure(error.error.description));
            } else {
                throw error;
            }
        });
};

const buttonRenewClicked = () => ({
    type: actionTypes.RA_SUITABILITY_TEST_BUTTON_RENEW_PRESSED,
});

const sendTestInProgress = () => ({
    type: actionTypes.RA_SUITABILITY_TEST_SEND_TEST_IN_PROGRESS,
});

const sendTestSuccess = response => ({
    type: actionTypes.RA_SUITABILITY_TEST_SEND_TEST_SUCCESS,
    payload: {
        response,
    },
});

const sendTestFailure = error => ({
    type: actionTypes.RA_SUITABILITY_TEST_SEND_TEST_FAILURE,
    payload: {
        error,
    },
});

const getSliceNumber = currentStep => {
    let step = currentStep;
    if (currentStep > 3) {
        step = currentStep + 12;
    }

    if (currentStep > 7) {
        step = currentStep + 13;
    }

    return step;
};

const mapAnswers = (
    immSuitabilityTest,
    currentStep,
    finishedTest,
    allowEleventhQuestion,
    immFlagBasedFeatures,
) => {
    const ffSustainabilityQuestions = immFlagBasedFeatures.get(
        SUSTAINABILITY_QUESTIONS_SUITABILITY_TEST_COUNTRIES,
    );
    const ffTestV6 = immFlagBasedFeatures.get(SUITABILITY_TEST_V6);
    let answers = immSuitabilityTest
        .get('answers')
        .map((answer, idQuestion) => {
            switch (idQuestion) {
                case '218':
                    return {
                        idAnswer: [horizonSliderValueToAnswer(answer)],
                        idQuestion,
                    };
                case '219':
                    return {
                        idAnswer: [riskSliderValueToAnswer(answer)],
                        idQuestion,
                    };
                case '320':
                    return {
                        idAnswer: [incomeValueToAnswer(answer)],
                        idQuestion,
                    };
                case '321':
                    return {
                        idAnswer: [outcomeValueToAnswer(answer)],
                        idQuestion,
                    };
                case '322':
                    return {
                        idAnswer: [networthSliderValueToAnswer(answer)],
                        idQuestion,
                    };
                default:
                    return {
                        idAnswer: [
                            typeof answer !== 'undefined'
                                ? answer.toString()
                                : '',
                        ],
                        idQuestion,
                    };
            }
        })
        .toArray();

    const sustainabilityAnswerQuestion401 = immSuitabilityTest.getIn([
        'answers',
        '401',
    ]);
    const isAnswer1ForQuestion401 =
        sustainabilityAnswerQuestion401 === 'answer1';
    const currentSustainabilityQuestionId = immSuitabilityTest.get(
        'currentSustainabilityQuestionId',
    );

    if (!allowEleventhQuestion && currentSustainabilityQuestionId === '400') {
        answers = answers.filter(
            answer =>
                answer.idQuestion !==
                immSuitabilityTest.get('currentSustainabilityQuestionId'),
        );
    }

    const sustainabilityAnswerQuestion101 = immSuitabilityTest.getIn([
        'answers',
        '101',
    ]);

    if (sustainabilityAnswerQuestion101 === 'answer1' && !ffTestV6) {
        answers = answers.filter(
            ans => !QUESTION_TO_FILTER_ON_1A_CASES.includes(ans.idQuestion),
        );
    }

    const sustainabilityAnswerQuestion103 = immSuitabilityTest.getIn([
        'answers',
        '103',
    ]);
    const retrieveTestVersion = immSuitabilityTest.get('retrieveTestVersion');
    if (
        sustainabilityAnswerQuestion103 === 'answer4' ||
        (!!retrieveTestVersion && retrieveTestVersion < 4)
    ) {
        answers = answers.filter(ans => ans.idQuestion !== '103');
    }

    const accordionQuestions = [
        '106',
        '107',
        '108',
        '109',
        '110',
        '111',
        '112',
        '113',
        '114',
        '115',
    ];

    answers = answers.map(question => {
        const existQuestion = accordionQuestions.find(
            idQuestion => idQuestion === question.idQuestion,
        );
        if (existQuestion && question.idAnswer[0] === '') {
            const newQuestion = { ...question, idAnswer: ['answer1'] };
            return newQuestion;
        } else {
            return question;
        }
    });

    if (ffSustainabilityQuestions) {
        if (isAnswer1ForQuestion401) {
            {
                answers = answers.map(ans => {
                    if (
                        ['402', '403', '404', '405', '500'].includes(
                            ans.idQuestion,
                        )
                    ) {
                        return {
                            idAnswer: [''],
                            idQuestion: ans.idQuestion,
                        };
                    } else return ans;
                });
            }
        }

        answers = answers.filter(
            answer => !['400'].includes(answer.idQuestion),
        );

        return answers;
    } else if (currentSustainabilityQuestionId === '400') {
        answers = answers.filter(
            answer =>
                !['401', '402', '403', '404', '405', '500'].includes(
                    answer.idQuestion,
                ),
        );
        return answers;
    }

    if (!finishedTest) {
        answers = answers.slice(0, getSliceNumber(currentStep));
        if (currentStep > 6) {
            answers.push({
                idAnswer: [
                    immSuitabilityTest.getIn(['answers', '701']).toString(),
                ],
                idQuestion: '701',
            });
        }
    }

    return answers;
};

const getTestPDFFetching = data => ({
    type: actionTypes.RA_SUITABILITY_TEST_GET_PDF_TEST_FETCHING,
    payload: data,
});

const getTestPDFSuccess = data => ({
    type: actionTypes.RA_SUITABILITY_TEST_GET_PDF_TEST_SUCCESS,
    payload: data,
});

const getTestPDFFailure = data => ({
    type: actionTypes.RA_SUITABILITY_TEST_GET_PDF_TEST_FAILURE,
    payload: data,
});

const getTestPDF = (testId, isModifiedTest) => (dispatch, getState) => {
    dispatch(getTestPDFFetching());
    const immFlagBasedFeatures = getState().flagBasedFeatures;
    let requestData = {
        query: {
            channel: 'OFI',
            modifiedTest: !!isModifiedTest,
            resultId: testId,
        },
    };

    if (
        immFlagBasedFeatures.get(
            SUSTAINABILITY_QUESTIONS_SUITABILITY_TEST_COUNTRIES,
        )
    ) {
        requestData = {
            query: {
                ...requestData.query,
                version: 5,
            },
        };
    } else if (immFlagBasedFeatures.get(SUITABILITY_TEST_V6)) {
        requestData = {
            query: {
                ...requestData.query,
                version: 6,
            },
        };
    }
    APIPost(
        dispatch,
        apiURLBuilder.getURL('raPdfSuitabilityTestV3'),
        requestData,
    )
        .then(response => {
            if (!response.errorMessage) {
                dispatch(getTestPDFSuccess(response));
            } else {
                dispatch(getTestPDFFailure());
            }
        })
        .catch(() => dispatch(getTestPDFFailure()));
};

const showModalNewQuestions = showModal => ({
    type: actionTypes.RA_SUITABILITY_TEST_SHOW_MODAL_NEW_QUESTIONS,
    payload: showModal,
});

const getChannel = () => {
    if (__CONTACT_CENTER__) {
        return isPrintOfficeMode() ? 'OFI' : 'CC';
    }
    return 'WEB';
};

const sendLogs = currentStep => (dispatch, getState) => {
    const immSuitabilityTest = getState().raSuitabilityTest;
    const { questions, answers } = immSuitabilityTest.toJS();
    const questionLogs = [];
    const listOfQuestions = [
        { step: SUITABILITY_TEST_STEP_11, listQuestion: ['401'] },
        {
            step: SUITABILITY_TEST_STEP_12,
            listQuestion: ['402', '403', '404', '405'],
        },
        { step: SUITABILITY_TEST_MODAL_QUESTION_500, listQuestion: ['500'] },
    ];

    const questionToSend = listOfQuestions.find(
        item => item.step === currentStep,
    );

    if (questionToSend) {
        const { listQuestion } = questionToSend;
        listQuestion.forEach(item => {
            if (answers[item]) {
                const question = questions[item];
                const answerId = answers[item];
                const dataAnswer = question.answers.find(
                    answer => answer.id === answerId,
                );
                questionLogs.push({
                    answerId: dataAnswer.id,
                    answerText: dataAnswer.label.title,
                    questionId: item,
                    questionText: question.title,
                });
            }
        });

        const request = {
            query: {
                channel: getChannel(),
                originCountry: 'ES',
                questionList: questionLogs,
            },
        };
        return APIPost(
            dispatch,
            apiURLBuilder.getURL('raSendLogsForNewTestQuestions'),
            request,
        );
    }
};

const dmsManagementPlanInitFetching = () => ({
    type: actionTypes.RA_SUITABILITY_TEST_DMS_INIT_FETCHING,
});

const dmsManagementPlanInitSuccess = response => {
    return {
        type: actionTypes.RA_SUITABILITY_TEST_DMS_INIT_SUCCESS,
        payload: { operationProcessId: response.operationProcessId },
    };
};

const dmsManagementPlanInitError = () => ({
    type: actionTypes.RA_SUITABILITY_TEST_DMS_INIT_ERROR,
});

const dmsManagementPlanInit = () => dispatch => {
    const requestData = {
        query: {
            implicitCosts: null,
            wealthOperationProcessType: 'WEALTH_PDF_SUITABILITY_TEST',
        },
    };

    dispatch(dmsManagementPlanInitFetching());

    return APIPost(dispatch, apiURLBuilder.getURL('raDMSInit'), requestData)
        .then(response => {
            dispatch(dmsManagementPlanInitSuccess(response));
        })
        .catch(() => {
            dispatch(dmsManagementPlanInitError());
        });
};

const sendTest = (history, finishedTest, totalAnswers) => (
    dispatch,
    getState,
) => {
    dispatch(sendTestInProgress());
    const immSuitabilityTest = getState().raSuitabilityTest;
    const immFlagBasedFeatures = getState().flagBasedFeatures;
    const immCheckStatus = getState().raCheckStatus;
    const lastStepIndex = getState().raWizard.getIn([
        'persistedWizards',
        'SUITABILITY_TEST',
        'lastStepIndex',
    ]);
    const allowEleventhQuestion = immFlagBasedFeatures.get(
        SUSTAINABILITY_QUESTIONS_SUITABILITY_TEST,
    );
    const copyVersion = immSuitabilityTest.get('copyVersion');
    const currentSutainabilityQuestionId = immSuitabilityTest.get(
        'currentSustainabilityQuestionId',
    );
    const storeQuestion = mapAnswers(
        immSuitabilityTest,
        lastStepIndex,
        finishedTest,
        allowEleventhQuestion,
        immFlagBasedFeatures,
    );

    let checkStatus = immCheckStatus.get('newRoboCustomer')
        ? SUITABILITY_TEST_NO_TEST
        : immCheckStatus.get('testExpired')
        ? SUITABILITY_TEST_EXPIRED
        : SUITABILITY_TEST_VALID;
    if (
        immCheckStatus.get('unSignedTest') ||
        immCheckStatus.get('testInProgress')
    ) {
        checkStatus = SUITABILITY_TEST_IN_PROGRESS;
    }
    if (immCheckStatus.get('nonSuitableTest')) {
        checkStatus = SUITABILITY_TEST_REDO;
    }
    checkStatus = 1;
    const ffTestV6 = immFlagBasedFeatures.get(SUITABILITY_TEST_V6);
    const version = ffTestV6
        ? 6
        : currentSutainabilityQuestionId === '400'
        ? 4
        : 5;
    const request = {
        query: {
            allQuestions: finishedTest.toString(),
            checkStatus: checkStatus.toString(),
            storeQuestion,
            copyVersion: copyVersion.toString(),
            version: version,
        },
    };

    const url = ffTestV6 ? 'raSendTestQuestionsV4' : 'raSendTestQuestions';

    return APIPost(dispatch, apiURLBuilder.getURL(url), request)
        .then(response => {
            const result = response.results[0];
            if (finishedTest) {
                dispatch(getTestResult(0, true));
            }
            dispatch(sendTestSuccess(response));
            dispatch(checkStatusActions.checkStatus());
            if (totalAnswers) {
                if (totalAnswers === 10) {
                    recordLink(
                        PROC_RA_SUITABILITY_TEST,
                        PROC_RA_SUITABILITY_TEST_CURRENT_ANSWER +
                            PROC_RA_SUITABILITY_TEST_STEP_10,
                        immSuitabilityTest.getIn(['answers', '323']),
                    );
                } else if (totalAnswers === 11) {
                    recordLink(
                        PROC_RA_SUITABILITY_TEST,
                        PROC_RA_SUITABILITY_TEST_CURRENT_ANSWER +
                            PROC_RA_SUITABILITY_TEST_STEP_11,
                        immSuitabilityTest.getIn(['answers', '401']),
                    );
                }
            }
            recordLink(
                PROC_RA_SUITABILITY_TEST,
                PROC_RA_SUITABILITY_TEST_FINISH_FORM,
                !result.passedTest || result.clientRiskProfileTitle === null
                    ? EVENT_UNSUITABLE_PROFILE
                    : result.clientRiskProfileTitle,
            );
            if (isPrintOfficeMode()) {
                const testId = !!response.results && response.results[0].id;
                if (testId) {
                    const hasZeroQuestion = !!immSuitabilityTest.getIn([
                        'answers',
                        RA_ZERO_QUESTION_ID,
                    ]);
                    dispatch(getTestPDF(testId, hasZeroQuestion));
                }
            }
            immFlagBasedFeatures.get(EVIDENCE_WEALTH_SUITABILITY_TEST) &&
                dispatch(dmsManagementPlanInit());
        })
        .catch(error => {
            if (error.error) {
                dispatch(sendTestFailure(error.error.description));
                if (finishedTest) {
                    dispatch(errorActions.show('', true, history));
                }
            } else {
                throw error;
            }
        });
};

const setHistoricalTest = (results, retryTestStatus) => ({
    type: actionTypes.RA_SUITABILITY_TEST_HISTORICAL_TEST_SUCCESS,
    payload: {
        results,
        retryTestStatus,
    },
});

const enableRetryTest = () => ({
    type: actionTypes.RA_SUITABILITY_TEST_RETRY_TEST_ENABLED,
});

const historicalTestRequest = () => ({
    type: actionTypes.RA_SUITABILITY_TEST_HISTORICAL_TEST_REQUEST,
});

const getHistoricalTest = () => dispatch => {
    dispatch(historicalTestRequest());

    const language = getFormattedLanguage();
    const params = {
        language,
    };

    return APIGet(
        dispatch,
        apiURLBuilder.getURL('raHistoricalTest', params),
    ).then(response => {
        const { error, results, retryTestStatus } = response;
        if (error) {
            throw error;
        } else {
            dispatch(setHistoricalTest(results, retryTestStatus));
        }
    });
};

const shouldDisplayModalProductKnowledge = () => (dispatch, getState) => {
    const immWizard = getState().raWizard;
    const immSuitabilityTest = getState().raSuitabilityTest;
    const immAnswers = immSuitabilityTest.get('answers');
    const stepFourIsPristine = immAnswers
        .slice(4, 16)
        .every(v => v === 'answer1');
    if (!stepFourIsPristine) {
        wizardActions
            .findStepAndCategoryIndexes(
                immWizard,
                SUITABILITY_TEST,
                SUITABILITY_TEST_STEP_4,
            )
            .then(indexes => {
                dispatch(
                    wizardActions.shouldDisplayModal(
                        SUITABILITY_TEST,
                        false,
                        indexes.category,
                        indexes.step,
                    ),
                );
            });
    }
};

const getTestQuestionsRequest = () => ({
    type: actionTypes.RA_SUITABILITY_GET_TEST_QUESTIONS_REQUEST,
});

const getTestQuestionsSuccess = (data, readOnly) => {
    return {
        type: actionTypes.RA_SUITABILITY_GET_TEST_QUESTIONS_SUCCESS,
        payload: { data, readOnly },
    };
};

const getTestQuestionsFailure = error => ({
    type: actionTypes.RA_SUITABILITY_GET_TEST_QUESTIONS_FAILURE,
    payload: { error },
});

const setSustainabilityQuestionId = () => (dispatch, getState) => {
    const immFlagBasedFeatures = getState().flagBasedFeatures;
    const getShowedSustainabilityQuestionId = () => {
        if (
            immFlagBasedFeatures.get(
                SUSTAINABILITY_QUESTIONS_SUITABILITY_TEST_COUNTRIES,
            ) &&
            !immFlagBasedFeatures.get(SUSTAINABILITY_QUESTIONS_SUITABILITY_TEST)
        ) {
            return '401';
        } else {
            return '400';
        }
    };
    const currentSustainabilityQuestionId = getShowedSustainabilityQuestionId();
    dispatch({
        type: actionTypes.RA_SUITABILITY_SET_SUSTAINABILITY_QUESTION_ID,
        payload: currentSustainabilityQuestionId,
    });
};

const getInvestmentExperienceSuccess = (
    dataInvestmentExperience,
    showInvestmentExperienceModal,
) => {
    return {
        type: actionTypes.RA_SUITABILITY_GET_INVESTMENT_EXPERIENCE_SUCCESS,
        payload: { dataInvestmentExperience, showInvestmentExperienceModal },
    };
};

const handleCloseModalInvestmentExperience = () => {
    return {
        type:
            actionTypes.RA_SUITABILITY_HANDLE_CLOSE_MODAL_INVESTMENT_EXPERIENCE,
        payload: false,
    };
};

const getInvestmentExperience = () => (dispatch, getState) => {
    const immFlagBasedFeatures = getState().flagBasedFeatures;
    const immCheckStatus = getState().raCheckStatus;
    const showInvestmentExperienceModal =
        immCheckStatus.get('checkStatus') === 1;
    if (
        immFlagBasedFeatures.get(
            MIFID_TEST_CONTRACTED_PRODUCTS_COHERENCE_CONTROL,
        )
    ) {
        const requestData = {
            header: {
                version: 2,
            },
        };

        return APIGet(
            dispatch,
            apiURLBuilder.getURL('brokerInvestmentExperience'),
            requestData,
        ).then(response =>
            dispatch(
                getInvestmentExperienceSuccess(
                    response,
                    showInvestmentExperienceModal,
                ),
            ),
        );
    }
};

const getTestQuestions = readOnly => (dispatch, getState) => {
    dispatch(setSustainabilityQuestionId());
    dispatch(getTestQuestionsRequest());
    const language = getFormattedLanguage();
    const immCheckStatus = getState().raCheckStatus;
    const immSuitabilityTest = getState().raSuitabilityTest;
    const immFlagBasedFeatures = getState().flagBasedFeatures;

    const isNoValid =
        (immCheckStatus.get('newRoboCustomer') ||
            immCheckStatus.get('testExpired') ||
            immCheckStatus.get('nonSuitableTest')) &&
        !immCheckStatus.get('testInProgress') &&
        !immCheckStatus.get('unSignedTest');

    const isUnsuitable = immCheckStatus.get('nonSuitableTest');
    const isNoFinished =
        immCheckStatus.get('testInProgress') ||
        immCheckStatus.get('unSignedTest');

    if ((!isNoValid || !isUnsuitable) && isNoFinished) {
        immFlagBasedFeatures.get(EVIDENCE_WEALTH_SUITABILITY_TEST) &&
            dispatch(dmsManagementPlanInit());
    }

    const currentSutainabilityQuestionId = immSuitabilityTest.get(
        'currentSustainabilityQuestionId',
    );

    let checkStatus = immCheckStatus.get('newRoboCustomer')
        ? SUITABILITY_TEST_NO_TEST
        : immCheckStatus.get('testExpired')
        ? SUITABILITY_TEST_EXPIRED
        : SUITABILITY_TEST_NO_TEST;

    if (immCheckStatus.get('testInProgress')) {
        checkStatus = SUITABILITY_TEST_IN_PROGRESS;
    }

    if (immCheckStatus.get('unSignedTest')) {
        if (__CONTACT_CENTER__ && readOnly) {
            checkStatus = SUITABILITY_TEST_VALID;
        } else {
            dispatch(getTestResult(0, true));
            checkStatus = SUITABILITY_TEST_IN_PROGRESS;
        }
    }

    if (
        __CONTACT_CENTER__ &&
        !immCheckStatus.get('newRoboCustomer') &&
        !immCheckStatus.get('testExpired')
    ) {
        checkStatus = SUITABILITY_TEST_VALID;
    }
    const ffTestV6 = immFlagBasedFeatures.get(SUITABILITY_TEST_V6);
    const version = ffTestV6
        ? 6
        : currentSutainabilityQuestionId === '400'
        ? 4
        : 5;
    const params = {
        checkStatus,
        language,
        version: version,
    };

    const url = ffTestV6
        ? 'raRetrieveTestQuestionsV5'
        : 'raRetrieveTestQuestions';

    return APIGet(dispatch, apiURLBuilder.getURL(url, params))
        .then(response => {
            dispatch(setSustainabilityQuestionId(getState().raSuitabilityTest));
            dispatch(getTestQuestionsSuccess(response, readOnly));
            const immSuitabilityTest = getState().raSuitabilityTest;
            const immQuestions = immSuitabilityTest.get('questions');
            const zeroQuestionNotAnswered = !immSuitabilityTest.getIn([
                'answers',
                RA_ZERO_QUESTION_ID,
            ]);
            if (!response.mappedTest) {
                dispatch(getInvestmentExperience());
            }
            if (isPrintOfficeMode() && !!response.mappedTest.testAnswered) {
                const testId = response.mappedTest.id;
                if (!!testId) {
                    dispatch(getTestPDF(testId, !zeroQuestionNotAnswered));
                }
            }
            const immLastAnswer = immSuitabilityTest.get('lastAnswer');
            const immWizard = getState().raWizard;

            // We have to disable displaying modals of past steps if the user already read them
            const immAnswers = immSuitabilityTest.get('answers');
            if (immLastAnswer) {
                const isZeroQuestionPresent = zeroQuestionPresent(
                    immQuestions,
                    readOnly,
                );
                const immLastAnswerIndex = immLastAnswer.get('stepIndex');
                const firstStepIndex =
                    isZeroQuestionPresent && zeroQuestionNotAnswered ? 1 : 0;
                for (
                    let currentStepIndex = firstStepIndex;
                    currentStepIndex <= immLastAnswerIndex;
                    currentStepIndex++
                ) {
                    wizardActions
                        .findStepAndCategoryIndexes(
                            immWizard,
                            SUITABILITY_TEST,
                            currentStepIndex,
                        )
                        .then(index => {
                            dispatch(
                                wizardActions.updateWizardStep(
                                    SUITABILITY_TEST,
                                    true,
                                    index.category,
                                    index.step,
                                    !isZeroQuestionPresent,
                                ),
                            );
                        });
                }
                // Modal should not pop up on current step, it should just turn on next step validation
                !isZeroQuestionPresent &&
                    dispatch(wizardActions.showModal(SUITABILITY_TEST, false));

                // Disable modals for step 4 and 7 only if the user has answered and completed those steps
                const lastAnswerStepIndex = immLastAnswer.get('stepIndex');
                if (lastAnswerStepIndex < 3) {
                    return;
                }

                const stepSevenAnswer = immAnswers.get('219');
                const stepSevenIsPristine = stepSevenAnswer === '';
                if (lastAnswerStepIndex >= 6 && !stepSevenIsPristine) {
                    const shouldDisplayModal = stepSevenAnswer === 0;
                    wizardActions
                        .findStepAndCategoryIndexes(
                            immWizard,
                            SUITABILITY_TEST,
                            SUITABILITY_TEST_STEP_7,
                        )
                        .then(indexes => {
                            dispatch(
                                wizardActions.shouldDisplayModal(
                                    SUITABILITY_TEST,
                                    shouldDisplayModal,
                                    indexes.category,
                                    indexes.step,
                                ),
                            );
                        });
                }
            } else {
                recordProcess(PROC_RA_SUITABILITY_TEST, PROC_STEP + 1);
            }

            const stepFourIsPristine = immAnswers
                .slice(4, 15)
                .every(v => v === 'answer1');
            if (!stepFourIsPristine) {
                wizardActions
                    .findStepAndCategoryIndexes(
                        immWizard,
                        SUITABILITY_TEST,
                        SUITABILITY_TEST_STEP_4,
                    )
                    .then(indexes => {
                        dispatch(
                            wizardActions.shouldDisplayModal(
                                SUITABILITY_TEST,
                                false,
                                indexes.category,
                                indexes.step,
                            ),
                        );
                    });
            }
        })
        .catch(error => {
            if (error.error) {
                dispatch(getTestQuestionsFailure(error.error.description));
            } else {
                throw error;
            }
        });
};

const signTestRequest = () => ({
    type: actionTypes.RA_SUITABILITY_TEST_SIGN_TEST_REQUEST,
});

const signTestSuccess = () => ({
    type: actionTypesContactCenter.RA_SUITABILITY_TEST_SIGN_TEST_SUCCESS,
});

const signTestFailure = error => ({
    type: actionTypes.RA_SUITABILITY_TEST_SIGN_TEST_FAILURE,
    payload: {
        error,
    },
});

const signTestCallback = (dispatch, getState, history, dataToken) => {
    const immProfile = getState().profile;
    const immSuitabilityTest = getState().raSuitabilityTest;
    const immFlagBasedFeatures = getState().flagBasedFeatures;
    const immResults = immSuitabilityTest.getIn(['results', 0]);
    const currentSutainabilityQuestionId = immSuitabilityTest.get(
        'currentSustainabilityQuestionId',
    );

    const dmsParams = {
        evidenceType: 'SIGN_DOCUMENT',
        operationProcessId: immSuitabilityTest.get('operationProcessId'),
    };
    const ffTestV6 = immFlagBasedFeatures.get(SUITABILITY_TEST_V6);
    const version = ffTestV6
        ? 6
        : currentSutainabilityQuestionId === '400'
        ? 4
        : 5;
    const getSignInput = {
        birthdate: immProfile.get('fechaNacimiento'),
        canal: __CONTACT_CENTER__ ? getCCOfficeChannel() : API_CHANNEL,
        clientRiskProfile: {
            clientRiskProfileDescription: immResults.get(
                'clientRiskProfileDescription',
            ),
            clientRiskProfileValue: immResults.get('clientRiskProfile'),
        },
        dateTest: immResults.get('timestamp'),
        documentNumber: immProfile.getIn([
            'documentoIdentificacion',
            'codigodocumpersonacorp',
        ]),
        email: PersonalDataHelper.getEmail(immProfile),
        language: getFormattedLanguage(),
        maxTypeOfProduct: immResults.get('maxTypeOfProduct'),
        signature: {
            dataToken,
        },
        name: immProfile.get('nombreCliente'),
        surname: immProfile.getIn(['apellidoUno', 'apellido']).trim(),
        resultId: immResults.get('id'),
        timeStamp: immResults.get('timestamp'),
        points: immResults.get('points') || 0,
        version: version,
        ...(immFlagBasedFeatures.get(EVIDENCE_WEALTH_SUITABILITY_TEST) && {
            ...dmsParams,
        }),
    };

    const url = ffTestV6 ? 'raSignTestV4' : 'raSignTest';
    return APIPost(dispatch, apiURLBuilder.getURL(url), {
        query: getSignInput,
    })
        .then(() => {
            dispatch(checkStatusActions.checkStatus());
            if (immFlagBasedFeatures.get(MODIFY_SUITABILITY_TEST)) {
                dispatch(signTestSuccess());
                brokerMyInvestments.outdateMyInvestments()(dispatch);
            } else {
                const simulationRoute = immSuitabilityTest.get('fromSetGoal')
                    ? '/myprofile/robo/setGoal'
                    : '/myprofile/robo/management';
                history.push(simulationRoute);
            }
            recordProcess(PROC_RA_SUITABILITY_TEST, PROC_END);
        })
        .catch(error => {
            recordProcess(PROC_RA_SUITABILITY_TEST, PROC_FAIL);

            if (error.error) {
                dispatch(signTestFailure(error.error.description));
                dispatch(errorActions.show('', history));
            } else {
                throw error;
            }
        });
};

const isReviewInProgress = () => ({
    type: actionTypes.RA_SUITABILITY_TEST_REVIEW_IN_PROGRESS,
});

const signTest = history => (dispatch, getState) => {
    dispatch(signTestRequest());
    signaturePatternActions.validateAndExecute(
        dispatch,
        getState,
        (dispatch, getState, dataToken) =>
            signTestCallback(dispatch, getState, history, dataToken),
    );
};

const reset = () => ({
    type: actionTypes.RA_SUITABILITY_TEST_RESET,
});

const validateResidentiality = (profile, type) => ({
    type: actionTypes.RA_NONRESIDENTIAL_MODAL_VALIDATION,
    payload: {
        profile,
        type,
    },
});

const closeNonresidentialModal = () => ({
    type: actionTypes.RA_NONRESIDENTIAL_MODAL_CLOSE,
});

const closeErrorFetchingCountryOfResidenceModal = () => ({
    type:
        actionTypesContactCenter.RA_ERROR_FETCHING_COUNTRY_OF_RESIDENCE_MODAL_CLOSE,
});

const resetAnswers = () => ({
    type: actionTypes.RA_SUITABILITY_TEST_RESET_ANSWERS,
});

const resetTestCompleted = () => ({
    type: actionTypes.RA_SUITABILITY_TEST_RESET_TEST_COMPLETED,
});

const setOrigin = (value, id = null) => ({
    type: actionTypes.RA_SUITABILITY_TEST_SET_ORIGIN,
    payload: {
        value,
        id,
    },
});

const continueWithUnsuccess = () => ({
    type: actionTypes.RA_CONTINUE_WITH_UNSUCCESS_TEST,
});

const setSustainabilityAnswer = value => dispatch => {
    const isStepCompleted = value !== '';

    dispatch(wizardActions.updateWizardStep(SUITABILITY_TEST, isStepCompleted));
    dispatch({
        type: actionTypes.RA_SUITABILITY_TEST_SET_SUSTAINABILITY_ANSWER,
        payload: {
            value,
        },
    });
};

const cleanCovenientsQuestions = () => dispatch => {
    dispatch(updateFinancialAwarenessOption(undefined));
    dispatch(updateToolsAwarenessOption(undefined));
    dispatch(updateMarketRiskOption(undefined));
    SUITABILITY_TEST_ACCORDION_QUESTION.forEach(id =>
        dispatch(selectAccordionButton(id.toString(), '')),
    );
};

const setSustainabilityInvestmentFactors = value => dispatch => {
    const isStepCompleted = value !== '';
    dispatch(wizardActions.updateWizardStep(SUITABILITY_TEST, isStepCompleted));
    dispatch({
        type:
            actionTypes.RA_SUITABILITY_TEST_SET_SUSTAINABILITY_INVESTMENT_FACTORS,
        payload: {
            value,
        },
    });
};
const setSustainabiltyPias = value => dispatch => {
    const isStepCompleted = value !== '';
    dispatch(wizardActions.updateWizardStep(SUITABILITY_TEST, isStepCompleted));
    dispatch({
        type: actionTypes.RA_SUITABILITY_TEST_SET_SUSTAINABILITY_PIAS,
        payload: {
            value,
        },
    });
};

const setSustainabiltyTaxonomia = value => dispatch => {
    const isStepCompleted = value !== '';
    dispatch(wizardActions.updateWizardStep(SUITABILITY_TEST, isStepCompleted));
    dispatch({
        type: actionTypes.RA_SUITABILITY_TEST_SET_SUSTAINABILITY_TAXONOMIA,
        payload: {
            value,
        },
    });
};

const setSustainabiltyInvestmentObjective = value => dispatch => {
    const isStepCompleted = value !== '';
    dispatch(wizardActions.updateWizardStep(SUITABILITY_TEST, isStepCompleted));
    dispatch({
        type:
            actionTypes.RA_SUITABILITY_TEST_SET_SUSTAINABILITY_INVESTMENT_OBJECTIVE,
        payload: {
            value,
        },
    });
};

const setSustainabiltyOurStrategies = value => dispatch => {
    const isStepCompleted = value !== '';
    dispatch(wizardActions.updateWizardStep(SUITABILITY_TEST, isStepCompleted));
    dispatch({
        type: actionTypes.RA_SUITABILITY_TEST_SET_SUSTAINABILITY_OUR_STRATEGIES,
        payload: {
            value,
        },
    });
};

const cleanSutainabilityExtraQuestions = () => dispatch => {
    dispatch(setSustainabiltyPias(undefined));
    dispatch(setSustainabiltyTaxonomia(undefined));
    dispatch(setSustainabiltyInvestmentObjective(undefined));
};

module.exports = {
    buttonRenewClicked,
    changeCheckedOption,
    cleanCovenientsQuestions,
    continueWithUnsuccess,
    enableRetryTest,
    getHistoricalTest,
    getTestResult,
    expandAccordionRow,
    getTestQuestions,
    isReviewInProgress,
    resetCoherenceError,
    selectAccordionButton,
    sendTest,
    showModalNewQuestions,
    setOrigin,
    setRetryReason,
    signTest,
    updateBackupPlanOption,
    updateCapitalRatioOption,
    updateFinancialAwarenessOption,
    updateKnowledgeOption,
    updateTemporalHorizonValue,
    updateToolsAwarenessOption,
    updateMarketRiskOption,
    updateVolatilityInputValue,
    updateVolatilityValue,
    updateIncomingValue,
    updateObjective,
    updateOutgoingValue,
    updateZeroQuestionOption,
    validateStep,
    shouldDisplayModalProductKnowledge,
    reset,
    resetTestCompleted,
    validateResidentiality,
    closeNonresidentialModal,
    closeErrorFetchingCountryOfResidenceModal,
    resetAnswers,
    getTestPDF,
    continueFromModalWarning,
    setSustainabilityAnswer,
    setSustainabilityInvestmentFactors,
    setSustainabiltyPias,
    setSustainabiltyTaxonomia,
    setSustainabiltyInvestmentObjective,
    setSustainabiltyOurStrategies,
    cleanSutainabilityExtraQuestions,
    sendLogs,
    handleCloseModalInvestmentExperience,
};
